import React, { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import API from "../../../../utils/API";
import SelectField from '../../../../components/inputs/selectField';

class AddSimpleZebraDeviceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activeSimpleZebraDevices: [],
            options: [],
            selectedSimpleZebraDevice: null,
            selectedSimpleZebraDeviceFriendlyName: '',
            requiredFieldsFilled: false,
        }
    }

    async componentDidMount() {

        await API().get(`/getActiveZebraPrinters`).then((res) => {
            if (res.data) {
                let options = res.data.activeSimpleZebras.map((device) => {
                    let deviceName = device.friendlyName || 'Unnamed Device';
                    return { label: deviceName, value: device._id };
                });
                this.setState({ activeSimpleZebraDevices: res.data.activeZebraPrinters, options: options });

            }
        });
    }


    addSimpleZebraDevice = async () => {
        const { orgId, eventId, toggle, checkInAppConfiguration } = this.props;
        const payload = {
            organizationId: orgId,
            eventId: eventId,
            simpleZebraId: this.state.selectedSimpleZebraDevice.value,
            friendlyName: this.state.selectedSimpleZebraDeviceFriendlyName,
        };


        await API().patch(`/patchActiveZebraPrinter`, payload).then((res) => {
            if (res.data) {

                let updatedActiveSimpleZebraDevices = checkInAppConfiguration.zebraPrinters || [];
                let updatedZebra = res.data.zebraPrinter;
                const existingIndex = updatedActiveSimpleZebraDevices.findIndex(device => device._id === updatedZebra._id);
                if (existingIndex !== -1) {
                    updatedActiveSimpleZebraDevices[existingIndex] = updatedZebra;
                } else {
                    updatedActiveSimpleZebraDevices.push(updatedZebra);
                }
                this.props.updatedActiveSimpleZebraDevices(updatedActiveSimpleZebraDevices);
                toggle();
            }
        });
    }



    render() {
        const { isOpen, toggle, submitting } = this.props;
        const { options, activeSimpleZebraDevices, selectedSimpleZebraDeviceFriendlyName, selectedSimpleZebraDevice } = this.state;


        let requiredFieldsFilled = false;
        if (selectedSimpleZebraDevice) {
            if (selectedSimpleZebraDevice.label == 'Unnamed Device') {
                if (selectedSimpleZebraDeviceFriendlyName.trim() != '') {
                    requiredFieldsFilled = true;
                }
            } else {
                requiredFieldsFilled = true;
            }
        }



        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Add SimpleZebra Device"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <SelectField
                                label="Select SimpleZebra Device"
                                value={this.state.selectedSimpleZebraDevice}
                                options={options}
                                onChange={(e) => {
                                    let selectedSimpleZebraDeviceFriendlyName = '';
                                    if (e.label != 'Unnamed Device') {
                                        selectedSimpleZebraDeviceFriendlyName = e.label;
                                    }
                                    this.setState({ selectedSimpleZebraDevice: e, selectedSimpleZebraDeviceFriendlyName: selectedSimpleZebraDeviceFriendlyName });
                                }}
                            />

                            {selectedSimpleZebraDevice && selectedSimpleZebraDevice.label == 'Unnamed Device' &&
                                <InputField
                                    label="Friendly Name"
                                    value={selectedSimpleZebraDeviceFriendlyName}
                                    onChange={(e) => {
                                        this.setState({ selectedSimpleZebraDeviceFriendlyName: e.target.value });
                                    }}
                                />
                            }


                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Add ' : 'Adding...'}
                actionButton={() => this.addSimpleZebraDevice()}
                actionButtonDisabled={submitting || !requiredFieldsFilled}
            ></FieldModal>
        </div>
    }
}

export default AddSimpleZebraDeviceModal;